import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {required} from '../../common/Form/rules'
import Select from 'react-select'
import AddressBookImg from '../../../_static/images/address_book.png'

// TODO fix bug on not destroying form when update
class Form extends Component {
    render() {
        const {type, successMessage, confirmText, okButtonTxt, handleOpenAddressBooksModal, handleSubmit, submitSucceeded, error, submitting, onSubmit, handleClose, qbmEntity, categories = [], qbmId} = this.props
        const {formatMessage} = this.context
        const {resetForm} = this.props

        const hideFormOnAddMore = type !== "create"

        return (
            <form onSubmit={handleSubmit} className="create-dialog-form">
                {
                    ["create", "update"].includes(type) &&
                    <Field
                        name = "name"
                        id = "name"
                        type = "text"
                        component = {this.RenderInput}
                        validate = {[required]}
                        label = {formatMessage("textUserEmail")}
                        onChange = {(event, newValue) => {
                            if (submitSucceeded && newValue && resetForm) resetForm()
                        }}
                        ref = {this.getFieldRef}
                        autoComplete = "off"
                        handleOpenAddressBooksModal={handleOpenAddressBooksModal}
                    />
                }
                {
                    submitSucceeded &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-success">{successMessage}</div>
                    </div>
                }
                {
                    error &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-danger">{error}</div>
                    </div>
                }
                <div className="create-dialog-form__group flex">
                    {
                        type === "create" &&
                        <button
                            disabled={submitting}
                            onClick={handleSubmit((val,...rest)=>onSubmit({...val, hideForm : true},...rest))}
                            className="btn btn-primary mr-auto"
                            type="submit"
                        >{formatMessage("frmShareQuestionBtnAdd")}</button>
                    }
                    <button
                        onClick={handleClose}
                        className="btn btn-warning"
                        type="button"
                    >{formatMessage("frmShareQuestionBtnCancel")}</button>
                </div>
            </form>
        )
    }
    componentDidMount() {
        this.setFocus()
    }
    RenderInput = ({input, meta : {touched, error}, ...customProps}) => {
        const {label, type, id, autoComplete = "on", handleOpenAddressBooksModal} = customProps
        return (
            <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                <label htmlFor={id}>{label}</label>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <input
                        {...input}
                        id={id}
                        className="create-dialog-form__control"
                        type={type}
                        autoComplete = {autoComplete}
                    />
                    <img width={50} onClick={() => {
                        handleOpenAddressBooksModal()
                    }} style={{marginLeft: '10px', cursor: 'pointer'}} src={AddressBookImg} />
                </div>
                
                {
                    touched && error && <span style={{color:"red"}}>{this.context.formatMessage(error)}</span>
                }
            </div>
        )
    }
    getFieldRef = ref => {
        if (ref) this.input = findDOMNode(ref).querySelector('input')
    }
    setFocus = () => this.input && this.input.focus()

    static contextTypes = {formatMessage: PropTypes.any}
}

export default Form


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmSendModal/Form.jsx